/*
 * Renders a group of checkboxes that can be used to select
 * multiple values from a set of options.
 *
 * The corresponding component when rendering the selected
 * values is PropertyGroup.
 *
 */

import React, {useState ,useEffect} from 'react';
import { arrayOf, bool, node, shape, string } from 'prop-types';
import classNames from 'classnames';
import { FieldArray } from 'react-final-form-arrays';
import { FieldCheckbox, ValidationError } from '../../components';

import css from './FieldCheckboxGroup.module.css';

const FieldCheckboxRenderer = props => {
  const { className,
     rootClassName,
      label,
       twoColumns,
        id, 
        fields,
         options,
          meta,
           service,
            handleServiceChange,
             handleChecked,
              listingData,
               showWarning, 
               setShowWarning,
               checkedUnsavedService,
               submitDisabled,
               serviceOption,
               listing,
               isConsultationFilledUp,
               setBrainstormCheckboxesFilled,
               isBrainstormPriceSelected,
               brainstormOption1,
               setBrainstormOption1,
               brainstormOption2,
               setBrainstormOption2,
               brainstormOption3,
               setBrainstormOption3,
               brainstormOption4,
               setBrainstormOption4,
               brainstormOption5,
               setBrainstormOption5,
               brainstormOption6,
               setBrainstormOption6,
               personalOption,
               setPersonalOption,
               personalStatementEditingPrice,
               secondaryOption,
               setSecondaryOption,
               secondaryStatementEditingPrice,
               mockOption,
               mockPrice,
              setCheckedUnsavedService } = props;

  const classes = classNames(rootClassName || css.root, className);
  const listClasses = twoColumns ? classNames(css.list, css.twoColumns) : css.list;
  const uListClasses = service === "service" ? css.rowList : listClasses;
  const [checkedService, setCheckedService] = useState("consultation");

 



  
  return (
    <fieldset className={classes}>
      {label ? <legend>{label}</legend> : null}
      <ul className={uListClasses}>
        {options.map((option, index) => {
          const fieldId = `${id}.${option.key}`;

          const servicesLabelClasses =    fieldId === "service.consultation" ? (
            listingData.consultationId ? true : false
              ) : (
                fieldId === "service.personalStatementBrainstorm" ? (
                  listingData.brainstormId ? true : false
                    ) : (
                      fieldId === "service.mockInterview" ? (
                            listingData.mockId ? true : false
                            ) : (
                              fieldId === "service.personalStatementEditing" ? (
                                  listingData.personalStatementEditingId ? true : false
                                      ) : (
                                        fieldId === "service.secondaryStatementEditing" ? (
                                          listingData.secondaryStatementEditingId ? true : false
                                             ) : false
                                      ) 
                            )
                    )
                  )   


          
          return (
            <li key={fieldId} className={service === "service" ? (checkedService === option.key ? css.serviceItemSelected : css.serviceItemNotSelected) : css.item}>
              <FieldCheckbox
                id={fieldId}
                name={fields.name}
                label={option.label}
                value={option.key}
                service={service}
                setCheckedService={setCheckedService}
                handleServiceChange={handleServiceChange}
                handleChecked={handleChecked}
                listingData={listingData}
                showWarning={showWarning}
                setShowWarning={setShowWarning}
                checkedUnsavedService={checkedUnsavedService}
                setCheckedUnsavedService={setCheckedUnsavedService}
                submitDisabled={submitDisabled}
                serviceOption={serviceOption}
                listing={listing}
                editingService={props.editingService}
                isConsultationFilledUp={isConsultationFilledUp}
                setBrainstormCheckboxesFilled={setBrainstormCheckboxesFilled}
                isBrainstormPriceSelected={isBrainstormPriceSelected}
                brainstormOption1={brainstormOption1}
                setBrainstormOption1={setBrainstormOption1}
                brainstormOption2={brainstormOption2}
                setBrainstormOption2={setBrainstormOption2}
                brainstormOption3={brainstormOption3}
                setBrainstormOption3={setBrainstormOption3}
                brainstormOption4={brainstormOption4}
                setBrainstormOption4={setBrainstormOption4}
                brainstormOption5={brainstormOption5}
                setBrainstormOption5={setBrainstormOption5}
                brainstormOption6={brainstormOption6}
                setBrainstormOption6={setBrainstormOption6}
                personalOption={personalOption}
                setPersonalOption={setPersonalOption}
                personalStatementEditingPrice={personalStatementEditingPrice}
                secondaryOption={secondaryOption}
                setSecondaryOption={setSecondaryOption}
                secondaryStatementEditingPrice={secondaryStatementEditingPrice}
                mockOption={mockOption}
                mockPrice={mockPrice}
              />
            </li>
          );
        })}
      </ul>
      <ValidationError fieldMeta={{ ...meta }} />
    </fieldset>
  );
};

FieldCheckboxRenderer.defaultProps = {
  rootClassName: null,
  className: null,
  label: null,
  twoColumns: false,
};

FieldCheckboxRenderer.propTypes = {
  rootClassName: string,
  className: string,
  id: string.isRequired,
  label: node,
  options: arrayOf(
    shape({
      key: string.isRequired,
      label: node.isRequired,
    })
  ).isRequired,
  twoColumns: bool,
};

const FieldCheckboxGroup = props => <FieldArray component={FieldCheckboxRenderer} {...props} />;

// Name and component are required fields for FieldArray.
// Component-prop we define in this file, name needs to be passed in
FieldCheckboxGroup.propTypes = {
  name: string.isRequired,
};

export default FieldCheckboxGroup;
